import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ElementRef, inject, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormBuilder, ReactiveFormsModule, ValidatorFn, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'ez-reset-password',
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResetPasswordComponent {
  username: string;
  forgotPasswordUrl: string;
  errorMessage: string;
  passwordLinkInvalid: boolean;

  readonly #fb = inject(FormBuilder);
  form;

  constructor(elementRef: ElementRef) {
    this.username = elementRef.nativeElement.getAttribute('username');
    this.forgotPasswordUrl = elementRef.nativeElement.getAttribute('forgot-password-url');
    this.errorMessage = elementRef.nativeElement.getAttribute('error-message');
    this.passwordLinkInvalid = elementRef.nativeElement.getAttribute('password-link-invalid') === 'password-link-invalid';

    this.form = this.#fb.group({
      username: [this.username, [Validators.required, Validators.maxLength(64)]],
      password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(64)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(64), this.createMatchValidator()]],
    });
  }

  private createMatchValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const password = this.form?.value.password;

      return password === control.value
        ? null
        : { passwordMismatch: true };
    };
  }
}
